"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popoverContainerHOC = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BZPopover = /*#__PURE__*/function (_Component) {
  _inherits(BZPopover, _Component);

  var _super = _createSuper(BZPopover);

  function BZPopover(props, context) {
    var _this;

    _classCallCheck(this, BZPopover);

    _this = _super.call(this, props, context); // this.propType = this.getPropTypes();

    _this.handleClick = function (e) {
      if (_this.props.disabled) {
        return;
      }

      _this.setState({
        show: !_this.state.show
      });
    };

    _this.state = {
      show: false,
      id: Date.now()
    };
    return _this;
  }

  _createClass(BZPopover, [{
    key: "hidePopover",
    value: // getPropTypes() {
    //     return {
    //         button: PropTypes.element,
    //         popover: PropTypes.element,
    //         cls: PropTypes.string,
    //         placement: PropTypes.string,
    //         title: PropTypes.string,
    //         container: PropTypes.element
    //     }
    // }
    function hidePopover() {
      this.setState({
        show: false
      });
      this.refs.overlayTriggerBtn.hide();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var popoverWithProps = _react.default.Children.map([this.props.popover], function (child) {
        return /*#__PURE__*/(0, _react.cloneElement)(child, {
          hidePopover: _this2.hidePopover.bind(_this2)
        });
      });

      popoverWithProps = popoverWithProps && popoverWithProps[0];

      var popoverClick = /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover, {
        ref: "popover",
        id: this.state.id,
        title: this.props.title,
        className: this.props.cls
      }, popoverWithProps);

      var disabled = this.props.disabled;
      var overlay = disabled ? this.props.button : /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
        container: this.context.bzOverlayContainer,
        ref: "overlayTriggerBtn",
        defaultOverlayShown: this.props.defaultOverlayShown || false,
        onHide: this.props.onHide || null,
        onExited: this.props.onExited,
        className: this.props.cls,
        rootClose: true,
        trigger: this.props.trigger || 'click',
        placement: this.props.placement,
        overlay: popoverClick
      }, this.props.button);
      return overlay;
    }
  }]);

  return BZPopover;
}(_react.Component);

_defineProperty(BZPopover, "contextTypes", {
  bzOverlayContainer: _propTypes.default.object
});

var popoverContainerHOC = function popoverContainerHOC(component) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_component) {
    _inherits(_class, _component);

    var _super2 = _createSuper(_class);

    function _class() {
      _classCallCheck(this, _class);

      return _super2.apply(this, arguments);
    }

    _createClass(_class, [{
      key: "getChildContext",
      value: function getChildContext() {
        return {
          bzOverlayContainer: this
        };
      }
    }]);

    return _class;
  }(component), _defineProperty(_class, "childContextTypes", _objectSpread(_objectSpread({}, component.childContextTypes || {}), {}, {
    bzOverlayContainer: _propTypes.default.object
  })), _temp;
};

exports.popoverContainerHOC = popoverContainerHOC;
var _default = BZPopover;
exports.default = _default;